<div [ngClass]="{'header':showClientBranding,'header1':!showClientBranding, 'otp-header': applyAdditionalStyles}">
    <div class="logo-frame" *ngIf="showClientBranding">
        <div>
            <img class="logo1" alt="Gep Logo" [src]="logo_gep"><span class="text-small">{{partnershipText}}</span>
        </div>
        <div>
            <img class="logo2" alt="Client Logo" [src]="logo_client" (error)="skipClientLogo($event)">
        </div>
    </div>
    <div class="logo-frame" *ngIf="!showClientBranding">
        <div>
            <img class="logo3" alt="Gep Logo" [src]="logo_gep">
        </div>
    </div>
    <div class="language-setting">
        <button *ngIf="showLanguageSettingIcon" class="language-button" (click)="loadLanguageSettings()">
            <span class="iconGlobe">
                <svg width="16" height="20" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_7070_26093)">
                        <path
                            d="M7.996 0.5C3.576 0.5 0 4.08 0 8.5C0 12.92 3.576 16.5 7.996 16.5C12.416 16.5 16 12.92 16 8.5C16 4.08 12.416 0.5 7.996 0.5ZM13.536 5.3H11.176C10.916 4.3 10.552 3.34 10.072 2.452C11.544 2.956 12.768 3.976 13.536 5.3ZM8 2.128C8.668 3.088 9.188 4.156 9.528 5.3H6.472C6.812 4.156 7.332 3.088 8 2.128ZM1.808 10.1C1.676 9.588 1.6 9.052 1.6 8.5C1.6 7.948 1.676 7.412 1.808 6.9H4.508C4.444 7.424 4.4 7.956 4.4 8.5C4.4 9.044 4.444 9.576 4.512 10.1H1.808ZM2.46 11.7H4.82C5.08 12.7 5.444 13.66 5.924 14.552C4.452 14.048 3.228 13.024 2.46 11.7ZM4.82 5.3H2.46C3.228 3.976 4.452 2.952 5.924 2.448C5.444 3.34 5.08 4.3 4.82 5.3ZM8 14.872C7.336 13.912 6.816 12.844 6.472 11.7H9.528C9.184 12.844 8.664 13.912 8 14.872ZM9.872 10.1H6.128C6.052 9.576 6 9.044 6 8.5C6 7.956 6.052 7.424 6.128 6.9H9.872C9.948 7.424 10 7.956 10 8.5C10 9.044 9.948 9.576 9.872 10.1ZM10.076 14.548C10.556 13.656 10.92 12.7 11.18 11.7H13.54C12.768 13.024 11.544 14.044 10.076 14.548ZM11.488 10.1C11.552 9.576 11.6 9.044 11.6 8.5C11.6 7.956 11.556 7.424 11.488 6.9H14.188C14.32 7.412 14.4 7.948 14.4 8.5C14.4 9.052 14.324 9.588 14.188 10.1H11.488Z"
                            fill="#32588D" />
                    </g>
                    <defs>
                        <clipPath id="clip0_7070_26093">
                            <rect width="16" height="16" fill="white" transform="translate(0 0.5)" />
                        </clipPath>
                    </defs>
                </svg>
            </span>
            <span class="selectedLanguage">{{selectedLanguage}}</span>
            <span class="nsdicon-angle-down"></span>
        </button>
    </div>
    <div id="popId" class="popup-wrapper hidewrapper" (click)="hidePopup()" (keydown.enter)='hidePopup()'
        (keydown.space)='hidePopup()'>
        <ng-container #popupContainer></ng-container>
        <ng-template #popupTemplate let-manifestPath="manifestPath" let-config="config">
            <plugin-outlet [path]="manifestPath" [childConfig]="config" (onInitialize)="onInitialize($event)"
                (onActivate)="onActivate($event)" (onDeinitialize)="onDeinitialize($event)"></plugin-outlet>
        </ng-template>
    </div>
    <div class="languageSettings-wrapper hidewrapper">
        <ng-container #languageSettingsPopupContainer></ng-container>
        <ng-template #languageSettingsPopupTemplate let-manifestPath="manifestPath" let-config="config">
            <plugin-outlet [path]="manifestPath" [childConfig]="config" (onInitialize)="onInitialize($event)"
                (onActivate)="onActivate($event)" (onDeinitialize)="onDeinitialize($event)"></plugin-outlet>
            <div class="overlay header-overlay" (click)="hideLanguageSettings()"></div>
        </ng-template>
    </div>
</div>